import { useState, useEffect } from "react";
import { colors, fonts } from "../../constants/theme";
import logo from "../../assets/logo.png";

export default function PhoneMockup() {
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setPulse(prev => !prev);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        animation: "float 4.5s ease-in-out infinite",
      }}
    >
      {/* Background Ambient Glow */}
      <div
        style={{
          position: "absolute",
          top: "15%",
          left: "15%",
          width: "70%",
          height: "70%",
          background: `radial-gradient(circle, ${colors.lime}44 0%, transparent 70%)`,
          filter: "blur(50px)",
          pointerEvents: "none"
        }}
      />

      <style>{`
        @media (max-width: 640px) {
          .phone-floating-badge {
            display: none !important;
          }
        }
      `}</style>

      {/* Floating Badge Top Right */}
      <div
        className="phone-floating-badge"
        style={{
          position: "absolute",
          top: 30,
          right: -30,
          zIndex: 10,
          background: "rgba(13, 31, 20, 0.95)",
          backdropFilter: "blur(12px)",
          border: `1px solid ${colors.lime}`,
          borderRadius: 16,
          padding: ".6rem 1rem",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          boxShadow: "0 15px 30px rgba(0,0,0,0.6), 0 0 15px rgba(200,241,53,0.2)",
          animation: "float 3.5s ease-in-out infinite alternate"
        }}
      >
        <span style={{ fontSize: "1.1rem" }}>⚡</span>
        <div>
          <div style={{ fontSize: ".72rem", fontWeight: 800, color: "#ffffff" }}>Pago QR Instantáneo</div>
          <div style={{ fontSize: ".62rem", color: colors.lime }}>NFC Contactless 0.2s</div>
        </div>
      </div>

      {/* Floating Badge Bottom Left */}
      <div
        className="phone-floating-badge"
        style={{
          position: "absolute",
          bottom: 40,
          left: -35,
          zIndex: 10,
          background: "rgba(13, 31, 20, 0.95)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(16, 185, 129, 0.4)",
          borderRadius: 16,
          padding: ".6rem 1rem",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          boxShadow: "0 15px 30px rgba(0,0,0,0.6)",
          animation: "float 4s ease-in-out 1s infinite alternate"
        }}
      >
        <span style={{ fontSize: "1.1rem" }}>🥗</span>
        <div>
          <div style={{ fontSize: ".72rem", fontWeight: 800, color: "#ffffff" }}>Recomendación IA</div>
          <div style={{ fontSize: ".62rem", color: "#34d399" }}>Proteína balanceada</div>
        </div>
      </div>

      {/* Phone Titanium Outer Body */}
      <div
        style={{
          width: "min(300px, 78vw)",
          aspectRatio: "9 / 19.5",
          background: "linear-gradient(145deg, #2d3748 0%, #1a202c 50%, #0f172a 100%)",
          borderRadius: 48,
          padding: "10px",
          boxShadow:
            "0 40px 100px rgba(0,0,0,0.85), inset 0 0 0 2px rgba(255,255,255,0.15), 0 0 35px rgba(200,241,53,0.12)",
          position: "relative",
        }}
      >
        {/* Dynamic Island Notch */}
        <div
          style={{
            position: "absolute",
            top: 18,
            left: "50%",
            transform: "translateX(-50%)",
            width: 95,
            height: 24,
            background: "#000000",
            borderRadius: 20,
            zIndex: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 8px"
          }}
        >
          <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#06b6d4" }} />
          <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#050e08", border: "1px solid #1e293b" }} />
        </div>

        {/* Screen Content Container */}
        <div
          style={{
            width: "100%",
            height: "100%",
            borderRadius: 40,
            background: "linear-gradient(180deg, #050e08 0%, #0d2015 60%, #07140b 100%)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            padding: "36px 14px 14px",
            position: "relative"
          }}
        >
          {/* Status Bar */}
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: ".65rem", fontWeight: 700, color: "#ffffff", padding: "0 6px 10px" }}>
            <span>9:41</span>
            <div style={{ display: "flex", gap: "4px" }}>
              <span>5G</span>
              <span>100%</span>
            </div>
          </div>

          {/* User Header */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div style={{ width: 32, height: 32, borderRadius: 10, background: colors.lime, padding: "2px" }}>
                <img src={logo} alt="VittaLink" style={{ width: "100%", height: "100%", borderRadius: 8 }} />
              </div>
              <div>
                <div style={{ fontSize: ".72rem", fontWeight: 800, color: "#ffffff" }}>¡Hola, María! 👋</div>
                <div style={{ fontSize: ".58rem", color: colors.lime }}>480 Puntos Vitta</div>
              </div>
            </div>
            <div style={{ background: "rgba(200, 241, 53, 0.15)", color: colors.lime, fontSize: ".6rem", fontWeight: 800, padding: "3px 8px", borderRadius: 9999 }}>
              PRO
            </div>
          </div>

          {/* IA Goal Card */}
          <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(200,241,53,0.2)", borderRadius: 16, padding: "10px", marginBottom: "12px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: ".62rem", color: "#94a3b8", marginBottom: "4px" }}>
              <span>Meta diaria de nutrición</span>
              <span style={{ color: colors.lime, fontWeight: 700 }}>85% Completo</span>
            </div>
            <div style={{ height: 6, background: "rgba(255,255,255,0.1)", borderRadius: 3, overflow: "hidden" }}>
              <div style={{ width: "85%", height: "100%", background: `linear-gradient(90deg, ${colors.lime} 0%, #10b981 100%)` }} />
            </div>
          </div>

          {/* Nearest Vending Machine Widget */}
          <div style={{ background: "rgba(16, 185, 129, 0.12)", border: "1px solid rgba(16, 185, 129, 0.3)", borderRadius: 16, padding: "10px", marginBottom: "12px" }}>
            <div style={{ fontSize: ".6rem", fontWeight: 800, color: "#34d399", letterSpacing: ".04em", textTransform: "uppercase" }}>
              📍 Expendedora más cercana
            </div>
            <div style={{ fontSize: ".72rem", fontWeight: 800, color: "#ffffff", marginTop: "2px" }}>
              Vending #VL-01 • Edificio Central
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "6px" }}>
              <span style={{ fontSize: ".58rem", color: "#94a3b8" }}>Distancia: 15 metros</span>
              <span style={{ background: colors.lime, color: "#050e08", fontSize: ".58rem", fontWeight: 800, padding: "2px 8px", borderRadius: 9999 }}>
                Escanear QR
              </span>
            </div>
          </div>

          {/* Suggested Snack Item */}
          <div style={{ flex: 1, background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 16, padding: "10px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            <div style={{ fontSize: ".62rem", fontWeight: 700, color: colors.gray }}>Recomendación Nutricional</div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", margin: "6px 0" }}>
              <div style={{ width: 38, height: 38, borderRadius: 10, background: "rgba(200,241,53,0.1)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.2rem" }}>
                🥤
              </div>
              <div>
                <div style={{ fontSize: ".7rem", fontWeight: 800, color: "#ffffff" }}>Jugo Verde Detox</div>
                <div style={{ fontSize: ".58rem", color: colors.lime }}>80 kcal • Antiox</div>
              </div>
            </div>
            <button style={{ width: "100%", background: `linear-gradient(135deg, ${colors.lime} 0%, #a3e635 100%)`, border: "none", color: "#050e08", fontWeight: 800, fontSize: ".65rem", padding: "6px", borderRadius: 10, cursor: "pointer" }}>
              Reservar por RD$ 160
            </button>
          </div>

          {/* Bottom App Nav Bar */}
          <div style={{ display: "flex", justifyContent: "space-around", paddingTop: "8px", borderTop: "1px solid rgba(255,255,255,0.08)", marginTop: "10px", fontSize: ".9rem" }}>
            <span style={{ color: colors.lime }}>🏠</span>
            <span style={{ opacity: 0.5 }}>📍</span>
            <span style={{ opacity: 0.5 }}>📱</span>
            <span style={{ opacity: 0.5 }}>👤</span>
          </div>
        </div>
      </div>
    </div>
  );
}
